import { createMuiTheme } from '@material-ui/core';
import { brown as prim } from '@material-ui/core/colors';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: prim[800],
    },
    secondary: {
      main: prim[500],
    },
  },
});

export default theme;
